import * as actionTypes from "../../Action/actionTypes";

/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 7/10/19
 * Time: 2:36 PM
 */
const initialState = {
  provinces: [
    {
      key: 0,
      text: 'Western Province',
      value: 'Western Province'
    },
    {
      key: 1,
      text: 'Southern Province',
      value: 'Southern Province'
    },
    {
      key: 2,
      text: 'North Central Province',
      value: 'North Central Province'
    },
    {
      key: 3,
      text: 'North Western Province',
      value: 'North Western Province'
    },
    {
      key: 4,
      text: 'Northern Province',
      value: 'Northern Province'
    },
    {
      key: 5,
      text: 'Sabaragamuwa Province',
      value: 'Sabaragamuwa Province'
    },
    {
      key: 6,
      text: 'Eastern Province',
      value: 'Eastern Province'
    },
    {
      key: 7,
      text: 'Uva Province',
      value: 'Uva Province'
    },
    {
      key: 8,
      text: 'Central Province',
      value: 'Central Province'
    },
  ],

  districs : [

    {
      key: 'Ampara',
      text: 'Ampara',
      value: 'Ampara'
    },
    {
      key: 'Anuradhapura',
      text: 'Anuradhapura',
      value: 'Anuradhapura'
    },
    {
      key: 'Badulla',
      text: 'Badulla',
      value: 'Badulla'
    },
    {
      key: 'Batticaloa',
      text: 'Batticaloa',
      value: 'Batticaloa'
    },
    {
      key: 'Colombo',
      text: 'Colombo',
      value: 'Colombo'
    },
    {
      key: 'Galle',
      text: 'Galle',
      value: 'Galle'
    },
    {
      key: 'Gampaha',
      text: 'Gampaha',
      value: 'Gampaha'
    },
    {
      key: 'Hambantota',
      text: 'Hambantota',
      value: 'Hambantota'
    },
    {
      key: 'Jaffna',
      text: 'Jaffna',
      value: 'Jaffna'
    },
    {
      key: 'Kalutara',
      text: 'Kalutara',
      value: 'Kalutara'
    },
    {
      key: 'Kandy',
      text: 'Kandy',
      value: 'Kandy'
    },
    {
      key: 'Kegalle',
      text: 'Kegalle',
      value: 'Kegalle'
    },
    {
      key: 'Kilinochchi',
      text: 'Kilinochchi',
      value: 'Kilinochchi'
    },
    {
      key: 'Kurunegala',
      text: 'Kurunegala',
      value: 'Kurunegala'
    },
    {
      key: 'Mannar',
      text: 'Mannar',
      value: 'Mannar'
    },
    {
      key: 'Matale',
      text: 'Matale',
      value: 'Matale'
    },
    {
      key: 'Matara',
      text: 'Matara',
      value: 'Matara'
    },
    {
      key: 'Monaragala',
      text: 'Monaragala',
      value: 'Monaragala'
    },
    {
      key: 'Mullaitivu',
      text: 'Mullaitivu',
      value: 'Mullaitivu'
    },
    {
      key: 'NuwaraEliya',
      text: 'NuwaraEliya',
      value: 'NuwaraEliya'
    },
    {
      key: 'Polonnaruwa',
      text: 'Polonnaruwa',
      value: 'Polonnaruwa'
    },
    {
      key: 'Puttalam',
      text: 'Puttalam',
      value: 'Puttalam'
    },
    {
      key: 'Ratnapura',
      text: 'Ratnapura',
      value: 'Ratnapura'
    },
    {
      key: 'Trincomalee',
      text: 'Trincomalee',
      value: 'Trincomalee'
    },
    {
      key: 'Vavuniya',
      text: 'Vavuniya',
      value: 'Vavuniya'
    },

  ],


};
const reducer=(state=initialState,action)=>{
  switch(action.type){


    case actionTypes.BROUSER_HISTORY:
      return {
        ...state,
        history: action.value
      };

    default:
      return state;
  }
};

export default reducer;
